import React, { useState } from 'react';
import { FiUser, FiLock, FiSave } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const DashboardProfil = () => {
  const { user, updateProfile } = useAuth();
  const [form, setForm] = useState({ nama: user?.nama || '', organisasi: user?.organisasi || '', jabatan: user?.jabatan || '' });
  const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [saving, setSaving] = useState(false);
  const [savingPw, setSavingPw] = useState(false);

  const handleProfile = async (e) => {
    e.preventDefault(); setSaving(true);
    try { await updateProfile(form); toast.success('Profil berhasil diperbarui'); } catch (e) { toast.error('Gagal memperbarui profil'); } finally { setSaving(false); }
  };

  const handlePassword = async (e) => {
    e.preventDefault();
    if (pwForm.newPassword !== pwForm.confirmPassword) return toast.error('Password baru tidak cocok');
    if (pwForm.newPassword.length < 6) return toast.error('Password minimal 6 karakter');
    setSavingPw(true);
    try {
      await api.put('/auth/change-password', { currentPassword: pwForm.currentPassword, newPassword: pwForm.newPassword });
      toast.success('Password berhasil diubah');
      setPwForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (e) { toast.error(e.response?.data?.message || 'Gagal mengubah password'); } finally { setSavingPw(false); }
  };

  return (
    <div>
      <div className="dashboard-header"><h2>Profil Saya</h2><p>Kelola informasi akun Anda</p></div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '1.5rem' }}>
        {/* Profile Info */}
        <div className="card">
          <div className="card-body">
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              <div className="user-avatar" style={{ width: 64, height: 64, fontSize: '1.5rem' }}>{user?.nama?.charAt(0)}</div>
              <div>
                <h3 style={{ fontFamily: 'var(--font-body)', fontSize: '1.2rem' }}>{user?.nama}</h3>
                <div style={{ fontSize: '0.85rem', color: 'var(--gray-500)' }}>{user?.email}</div>
                <span className={`badge ${user?.role === 'admin' ? 'badge-danger' : user?.role === 'opd' ? 'badge-warning' : 'badge-info'}`} style={{ marginTop: '0.25rem' }}>{user?.role?.toUpperCase()}</span>
              </div>
            </div>
            <form onSubmit={handleProfile}>
              <div className="form-group"><label className="form-label"><FiUser style={{ marginRight: 4 }} size={13} /> Nama Lengkap</label><input className="form-input" value={form.nama} onChange={(e) => setForm({...form, nama: e.target.value})} required /></div>
              <div className="form-group"><label className="form-label">Organisasi</label><input className="form-input" value={form.organisasi} onChange={(e) => setForm({...form, organisasi: e.target.value})} /></div>
              <div className="form-group"><label className="form-label">Jabatan</label><input className="form-input" value={form.jabatan} onChange={(e) => setForm({...form, jabatan: e.target.value})} /></div>
              <button type="submit" className="btn btn-primary" disabled={saving}><FiSave size={15} /> {saving ? 'Menyimpan...' : 'Simpan Profil'}</button>
            </form>
          </div>
        </div>

        {/* Change Password */}
        <div className="card">
          <div className="card-body">
            <h3 style={{ fontFamily: 'var(--font-body)', fontSize: '1.1rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}><FiLock /> Ubah Password</h3>
            <form onSubmit={handlePassword}>
              <div className="form-group"><label className="form-label">Password Saat Ini</label><input className="form-input" type="password" value={pwForm.currentPassword} onChange={(e) => setPwForm({...pwForm, currentPassword: e.target.value})} required /></div>
              <div className="form-group"><label className="form-label">Password Baru</label><input className="form-input" type="password" value={pwForm.newPassword} onChange={(e) => setPwForm({...pwForm, newPassword: e.target.value})} required /></div>
              <div className="form-group"><label className="form-label">Konfirmasi Password Baru</label><input className="form-input" type="password" value={pwForm.confirmPassword} onChange={(e) => setPwForm({...pwForm, confirmPassword: e.target.value})} required /></div>
              <button type="submit" className="btn btn-accent" disabled={savingPw}><FiLock size={15} /> {savingPw ? 'Mengubah...' : 'Ubah Password'}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardProfil;
